const TYPE_MONOLINGUAL = 'TYPE_MONOLINGUAL';
const TYPE_BILINGUAL = 'TYPE_BILINGUAL';

export {
  TYPE_MONOLINGUAL,
  TYPE_BILINGUAL
};
